// Shared chart utilities for growth formatting, date filtering, and timeframe options

// --- Growth formatting ---

export const formatGrowth = (value: number) => {
  const pct = (value * 100).toFixed(1)
  const isPositive = value > 0
  const isNegative = value < 0
  return {
    text: `${isPositive ? "+" : ""}${pct}%`,
    color: isNegative ? "red.600" : isPositive ? "green.600" : "gray.600",
  }
}

// --- Timeframe options (HeadCountChart) ---

export type Timeframe = "monthly" | "180day" | "yearly"

export const TIMEFRAME_OPTIONS: { value: Timeframe; label: string; days: number }[] = [
  { value: "monthly", label: "Monthly", days: 30 },
  { value: "180day", label: "180 Day", days: 180 },
  { value: "yearly", label: "Yearly", days: 365 },
]

// --- Date range filtering (AttritionChart, HiresAndDeparturesChart) ---

export type DateRange = "all" | "1y" | "2y"

export const DATE_RANGE_OPTIONS: { value: DateRange; label: string }[] = [
  { value: "all", label: "All" },
  { value: "2y", label: "2 Year" },
  { value: "1y", label: "1 Year" },
]

export function filterByDateRange<T extends { date: string }>(data: T[], range: DateRange): T[] {
  if (range === "all") return data
  const now = new Date()
  const years = range === "1y" ? 1 : 2
  const cutoff = new Date(now.getFullYear() - years, now.getMonth(), now.getDate())
  return data.filter((d) => new Date(d.date) >= cutoff)
}

// --- Founding date filter (exclude data before company founding) ---

export function filterBeforeFoundingDate<T extends { date: string }>(data: T[], foundingDate?: string | null): T[] {
  if (!foundingDate) return data
  const cutoff = new Date(foundingDate)
  if (isNaN(cutoff.getTime())) return data
  return data.filter((d) => new Date(d.date) >= cutoff)
}
